import React from 'react';
import styled from 'styled-components';
import TopicsAll from "../../components/Topics";

function Topics (props) {

    const {} = props;

    return (
        <Container>
            <TopicsAll/>
        </Container>
    )
}

const Container = styled.div`
`
export default Topics;